import React from "react";
import { AlertCircle, Info, AlertTriangle, CheckCircle2 } from "lucide-react";

const SEV = {
  error: { color: "#EF4444", icon: AlertCircle },
  warning: { color: "#F59E0B", icon: AlertTriangle },
  info: { color: "#3B82F6", icon: Info },
  match: { color: "#00B67A", icon: CheckCircle2 },
};

export const FlagCard = ({ flag, testId }) => {
  const sev = SEV[flag.severity] || SEV.info;
  const Icon = sev.icon;
  return (
    <div
      data-testid={testId}
      className="flex items-start gap-3 p-4 bg-white rounded-md shadow-sm mb-3"
      style={{
        border: "1px solid var(--color-border)",
        borderLeftWidth: 4,
        borderLeftColor: sev.color,
      }}
    >
      <Icon size={20} color={sev.color} className="flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <div className="font-semibold text-sm text-[#0F2044] mb-1 uppercase tracking-wide">
          {flag.label}
        </div>
        <div className="text-sm text-gray-700">{flag.detail}</div>
      </div>
    </div>
  );
};

export default FlagCard;
